module.exports = __webpack_public_path__ + "static/media/device.cbb58fab.png";